import IconButton from '@components/IconButton/IconButton'
import { Manufacturer } from '@domain'
import { faTrash } from '@fortawesome/pro-solid-svg-icons'
import { Stack, Typography, useTheme } from '@mui/material'

type Props = Manufacturer & {
	onDelete: (id: Id) => void
}

export default function ListItem({ id, name, plid, onDelete }: Props) {
	const theme = useTheme()
	return (
		<Stack direction="row" alignItems="center" spacing={1}>
			<Typography variant="body2">{`${name}`}</Typography>
			<Typography variant="body2" color="textSecondary">{`(${plid})`}</Typography>
			<IconButton
				onClick={() => onDelete(id)}
				sx={{ color: theme.palette.error.main, p: 0.5 }}
				icon={faTrash}
				size="small"
				fontSize="1rem"
			/>
		</Stack>
	)
}
